import {Switch} from 'react-router-dom';
import {PropsRoute} from '@core/app/Routes';
import {CampaignRouteProps} from '../_routes';
import {CampaignPermissions} from './CampaignPermissions';
import {CampaignPermissionIndex} from './permission';

export function CampaignPermissionsIndex({
  user,
  organization,
  campaign,
}: CampaignRouteProps) {
  return (
    <Switch>
      <PropsRoute
        exact
        path='/:part(a|s|b|p)/:slug/campaigns/:campaignSlug/permissions'
        user={user}
        organization={organization}
        campaign={campaign}
        component={CampaignPermissions}
      />
      <PropsRoute
        path='/:part(a|s|b|p)/:slug/campaigns/:campaignSlug/permissions/:accessId'
        user={user}
        organization={organization}
        campaign={campaign}
        component={CampaignPermissionIndex}
      />
    </Switch>
  );
}
